import VariantSelects from './VariantSelects.js';

/**
 * Variant Radios
 */
export default class VariantRadios extends VariantSelects {
  /**
   * Class config
   * @type {object}
   */
  static config = {
    name: 'VariantRadios',
  };

  /**
   * Override update options
   * @returns {void}
   */
  updateOptions() {
    const fieldsets = Array.from(this.$el.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}
